import React, { useState } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useSelector } from "react-redux";

import DashboardLayout from "components/Layouts/DashboardLayout";
import Global404 from "components/Errors/Global404";
import ActivityInstancesHeader from "./ActivityInstancesHeader";
import { isAdmin } from "data/app/appSelectors";
import Instances from "./ActivityInstancesTable/Instances";
import { SearchSelectOptionProps } from "@alm/flow-ds/components";
import { DateOperators } from "../../../lib/api/services/workflow";

const ActivityInstances = () => {
	const [searchValue, setSearchValue] = useState<string>("");
	const [createdByValue, setCreatedByValue] =
		useState<SearchSelectOptionProps | null>(null);
	const [createdValue, setCreatedValue] = useState<string>("");
	const [operatorValue, setOperatorValue] = useState<DateOperators>("ALL");
	const [statusValue, setStatusValue] = useState<string>("all");

	const admin = useSelector(isAdmin);

	return (
		<DashboardLayout>
			<div className="container activity-instances">
				{admin ? (
					<>
						<div className="list-group-fixed-header">
							<ActivityInstancesHeader
								onChangeSearchValue={setSearchValue}
								onChangeCreatedByValue={setCreatedByValue}
								onChangeCreatedValue={setCreatedValue}
								onChangeOperatorValue={setOperatorValue}
								onChangeStatusValue={setStatusValue}
								createdBy={createdByValue}
								created={createdValue}
								operator={operatorValue}
								status={statusValue}
								search={searchValue}
							/>
						</div>
						<Switch>
							<Route
								exact
								path="/activity-instances"
								render={() => (
									<Instances
										status={statusValue}
										createdBy={createdByValue}
										created={createdValue}
										operator={operatorValue}
										search={searchValue}
										setStatusValue={setStatusValue}
										setCreatedByValue={setCreatedByValue}
										setCreatedValue={setCreatedValue}
										setOperatorValue={setOperatorValue}
										setSearchValue={setSearchValue}
										listFilter={
											statusValue === "all"
												? "ALL"
												: statusValue === "active"
												? "ACTIVE"
												: "COMPLETED"
										}
									/>
								)}
							/>
							<Route component={Global404} />
						</Switch>
					</>
				) : (
					<Redirect to="/403" />
				)}
			</div>
		</DashboardLayout>
	);
};

export default ActivityInstances;
